import type { FC } from "react";

import { Flex, Heading, Indicator } from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";

import { AnalysisObservationsButton } from "./AnalysisObservationsButton";

import {
  headingStyle,
  leadingButtonStyle,
  containerStyle,
} from "../AnalysisObservations.css";
import { indicatorStyle } from "./AnalysisObservationsHeader.css";

/**
 * @deprecated
 */
export type AnalysisObservationsHeaderProps = {
  currentIndex: number;
  currentLabel: string;
  previousLabel: string;
  nextLabel: string;
  previousIndex: number;
  nextIndex: number;
  handlePrevious: () => void;
  handleNext: () => void;
  subtitle?: string;
  headingVariant?: "secondary" | "default";
};

/**
 * @deprecated
 */
export const AnalysisObservationsHeader: FC<
  AnalysisObservationsHeaderProps
> = ({
  currentIndex,
  currentLabel,
  previousLabel,
  nextLabel,
  previousIndex,
  nextIndex,
  handlePrevious,
  handleNext,
  subtitle,
  headingVariant = "secondary",
}) => (
  <Flex gap="m" justify="space-between" className={containerStyle}>
    <AnalysisObservationsButton
      label={previousLabel}
      variant="previous"
      onClick={handlePrevious}
      className={mergeClasses(leadingButtonStyle)}
      index={previousIndex}
    />
    <Heading
      variant={headingVariant}
      align="center"
      title={
        <>
          <Indicator
            size="xs"
            inline
            variant="secondary"
            className={indicatorStyle}
          >
            {currentIndex + 1}
          </Indicator>{" "}
          {currentLabel}
        </>
      }
      subtitle={subtitle}
      className={mergeClasses(headingStyle)}
    />
    <AnalysisObservationsButton
      label={nextLabel}
      variant="next"
      onClick={handleNext}
      className={mergeClasses(leadingButtonStyle)}
      index={nextIndex}
    />
  </Flex>
);
